import styled from "styled-components"
import pesquisa from './assets/search.png';
import pin from './assets/pin.png'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Amanda_Braco from './assets/Amanda_braco.jpg'
import Card from '../../../components/CardServico'
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';


interface Props {
    imagem?: string,
}



const Titulo = styled.h2`
font-weight: 400;
 //   margin-bottom: 60px;
    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 55px;
    line-height: 1em;
    max-width: 600px;
   // margin-right: auto;
    margin-left: 20px;

    @media (max-width: 768px) {
        font-weight: 400;

    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 47px;
    line-height: 1em;
    max-width: 450px;
    //border: solid 2px green;
    margin-left: -22px;
  }

  @media (max-width: 390px) {
        font-weight: 400;

    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 43px;
    line-height: 1em;
    max-width: 450px;
    //border: solid 2px green;
    margin-left: -22px;
  }
`
const TituloSub = styled.h4`

    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 20px;
    line-height: 0em;
    max-width: 650px;
    margin-right: auto;

    @media (max-width: 768px) {
        color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 17px;
    line-height: 0em;
    max-width: 450px;
    margin-right: auto;
  }

  @media (max-width: 390px) {
    color: #333c4d;
    font-family: Titillium Web,sans-serif;
    font-size: 16px;
    line-height: 0em;
    max-width: 430px;
    margin-right: auto;
  }
    
`



const Linha1 = styled.div`
//border: solid 2px red;
width: 650px;  /* Tamanho fixo */
height: 800px; /* Tamanho fixo */

@media (max-width: 768px) {
    height: 550px;
  }
    
    
`
const Linha2 = styled.div`
//border: solid 2px green;
width: 650px;  /* Tamanho fixo */
height: 830px; /* Tamanho fixo */

@media (max-width: 768px) {
    height: 1050px;
  }

  @media (max-width: 390px) {
    height: 1130px;
  }
    
`
const Conteiner = styled.div`
  display: flex; 
  align-items: center; 
  width: 1500px; 
  margin-left: 10%;
  margin-top: 39px;

  @media (max-width: 768px) {
    display: grid; 
  align-items:  baseline; 
  width: 100%; 
  margin-left: 8%;
  margin-top: 39px;
  }
    
`

const ImagemEstilizada = styled.img`
  /* Aqui você pode adicionar estilos específicos para a imagem */
  border-radius: 10px; // Exemplo de estilo
  // Adicione mais estilos conforme necessário
  width: 600px;
  height: 500px;

  @media (max-width: 768px) {
    width: 400px;
  height: 300px;
  margin-left: -15px;
  }

  @media (max-width: 390px) {
    width: 350px;
  height: 289px;
  margin-left: -15px;
  }
`;

const EspacoCard = styled.h2`


    @media (max-width: 768px) {
       width: 395px;
      // height: 100px;
       margin-left: -57px;
        margin-bottom: 10px;
  }

  @media (max-width: 390px) {
    width: 343px;
      // height: 100px;
       margin-left: -57px;
        margin-bottom: 10px;
  }
`




export default function PrincipaisServicos() {
    return (
        <>

            <Conteiner>
                <Linha1>

                    <Titulo>
                        Nossos
                        <strong> principais serviços</strong>
                        <TituloSub>
                            O Direito é uma alavanca e não um obstáculo!
                        </TituloSub>
                    </Titulo>

                    <figure style={{ margin: 0, marginRight: '20px' }}>
                        <ImagemEstilizada
                            loading="lazy"
                            decoding="async"
                            
                            src={Amanda_Braco}
                            alt="Descrição da imagem"
                            title="Design sem nome (48) (1)"
                            sizes="(max-width: 2270px) 100vw, 2270px"
                        />
                    </figure>

                </Linha1>
                <Linha2>
                    <EspacoCard>

                    <Card
                        title="Consultoria"
                        description="Na Alves Advocacia, a consultoria é entendida como uma ferramenta essencial para o sucesso e a prevenção de conflitos. Oferecemos um serviço consultivo ativo, onde trabalhamos lado a lado com nossos clientes na tomada de decisões estratégicas, fundamentadas em análises jurídicas sólidas e proativas. Nosso objetivo é guiar você de maneira eficaz através do complexo mundo jurídico, mitigando riscos e identificando oportunidades."
                        imageUrl=""
                        icone={<CoPresentOutlinedIcon style={{ fontSize: 35 }} />}
                        serv="Consultoria ativa • Consultoria responsiva • Análise e elaboração de contratos"
                    />
                    </EspacoCard>
                    <EspacoCard>
                    <Card
                        title="Contencioso"
                        description="No cenário contencioso, possuímos uma equipe altamente qualificada e experiente, que se dedica a defender os interesses de nossos clientes em todas as esferas judiciais e administrativas. Nossa atuação incansável na proteção dos direitos de nossos clientes visa garantir o melhor resultado possível em cada caso, sempre com responsabilidade, ética e transparência."
                        imageUrl=""
                        icone={<BalanceOutlinedIcon style={{ fontSize: 35 }} />}
                        serv="Elaboração de petições • Representação judicial e administrativa • Audiências"

                    />
                    </EspacoCard>
                    <EspacoCard>
                    <Card
                        title="Assessoria Completa"
                        description="Na Alves Advocacia, o compromisso é com a excelência. Oferecemos um serviço jurídico completo, que abrange todas as áreas do direito e todas as etapas do processo. Da consultoria estratégica à resolução de litígios, nossa equipe de especialistas está preparada para atender a todas as suas necessidades jurídicas. Com Alves Advocacia, você tem a garantia de um serviço eficaz, profissional e totalmente dedicado à sua causa."
                        imageUrl=""
                        icone={<LockOpenOutlinedIcon style={{ fontSize: 35 }} />}
                        serv=""
                    />
                    </EspacoCard>


                </Linha2>
              
            </Conteiner>

        </>
    );
}